import {createListCollection, HStack, Icon, Portal, Select} from "@chakra-ui/react";
import {HiOutlineGlobeAsiaAustralia} from "react-icons/hi2";
import {useTranslation} from "react-i18next";
import {SUPPORTED_LANGUAGES} from "@/i18n";

const LanguageSelector = () => {
    const {i18n, t} = useTranslation();

    const languageCollection = createListCollection({
        items: SUPPORTED_LANGUAGES.map((code) => ({
            value: code,
            label: t(`language.${code}`),
        })),
    });

    const currentLanguage = SUPPORTED_LANGUAGES.includes(i18n.language)
        ? i18n.language
        : SUPPORTED_LANGUAGES[0];

    return (
        <HStack gap={1.5}>
            <Icon size={'md'} color={'#9A96A6'}>
                <HiOutlineGlobeAsiaAustralia />
            </Icon>
            <Select.Root
                collection={languageCollection}
                value={[currentLanguage]}
                size={"sm"}
                onValueChange={(e) => i18n.changeLanguage(e.value[0])}
            >
                <Select.HiddenSelect />
                <Select.Control>
                    <Select.Trigger
                        bg="transparent"
                        border="none"
                        color="#65616F"
                        px={0}
                        minW="64px"
                        _hover={{ color: "#17151F" }}
                    >
                        <Select.ValueText placeholder={t('language.select')} color="inherit" />
                    </Select.Trigger>
                    <Select.IndicatorGroup>
                        <Select.Indicator color="#9A96A6" />
                    </Select.IndicatorGroup>
                </Select.Control>
                <Portal>
                    <Select.Positioner>
                        <Select.Content bg="white" borderColor="#E7E4F0" boxShadow="0 8px 24px rgba(23,21,31,0.12)">
                            {languageCollection.items.map((language) => (
                                <Select.Item item={language} key={language.value} color={"#17151F"} _hover={{ bg: "#F6F6FB" }}>
                                    {language.label}
                                    <Select.ItemIndicator />
                                </Select.Item>
                            ))}
                        </Select.Content>
                    </Select.Positioner>
                </Portal>
            </Select.Root>
        </HStack>
    )
}

export default LanguageSelector;
